module.exports = {
    // 项目名称
    title: '全安一点通驾考平台',
    // logo 图片
    logo: 'http://pc.qaydtjg.com/assets/ico-1ccbb353.png',

    /**
     * @type {boolean} true | false
     * @description Whether fix the header
     */
    fixedHeader: true,

    /**
     * @type {boolean} true | false
     * @description Whether show the logo in sidebar
     */
    sidebarLogo: true,

    tagsView: true,

    // 全局按钮大小
    inputBtnSize: "mini",


}
